export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#1A1A1A] text-[#FAF9F6] pt-24 md:pt-32 pb-12 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 mb-24">
          <div className="col-span-12 md:col-span-6">
            <p className="overline text-[#A89680] mb-6">The Studio</p>
            <p className="font-serif-editorial text-2xl md:text-3xl leading-snug max-w-lg text-[#FAF9F6]/85">
              A branding studio for homes worth remembering — and worth
              paying more for. Independent, founder-led, and quietly obsessed
              with the details.
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="overline text-[#A89680] mb-6">Sitemap</p>
            <ul className="space-y-3 text-sm text-[#FAF9F6]/80">
              <li><a href="#work" className="hover-underline" data-testid="footer-link-work">Selected Work</a></li>
              <li><a href="#stats" className="hover-underline" data-testid="footer-link-stats">The Value</a></li>
              <li><a href="#packages" className="hover-underline" data-testid="footer-link-packages">Packages</a></li>
              <li><a href="#process" className="hover-underline" data-testid="footer-link-process">Process</a></li>
              <li><a href="#contact" className="hover-underline" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <p className="overline text-[#A89680] mb-6">Studio</p>
            <ul className="space-y-3 text-sm text-[#FAF9F6]/80">
              <li>
                <a href="mailto:contact@maison-locale.com" data-testid="footer-email" className="hover-underline">
                  contact@maison-locale.com
                </a>
              </li>
              <li>
                <a href="tel:+14803228573" data-testid="footer-phone" className="hover-underline">
                  +1 480 322 8573
                </a>
              </li>
              <li>Lisbon · Milano · London</li>
              <li>Instagram · @maisonlocale</li>
              <li>Available 2026 · Two files</li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="border-t border-white/10 pt-16">
          <h2
            data-testid="footer-wordmark"
            className="font-serif-editorial text-[22vw] md:text-[16vw] leading-[0.85] tracking-[-0.03em] font-light select-none"
          >
            Maison<span className="italic text-[#A89680]">Locale</span>.
          </h2>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs uppercase tracking-[0.22em] text-[#FAF9F6]/50">
          <p>© {new Date().getFullYear()} Maison Locale — Studio S.A.</p>
          <p>Made slowly, in Europe.</p>
        </div>
      </div>
    </footer>
  );
}
